// I18N — language switcher dropdown (EN / AR / SO).
import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../../i18n";
import "./LanguageSwitcher.css";

const LABELS = { en: "EN", ar: "AR", so: "SO" };
const FULL_LABELS = { en: "English", ar: "العربية", so: "Soomaali" };

const LanguageSwitcher = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const current = (i18n.language || "en").split("-")[0];
  const value = SUPPORTED_LANGUAGES.includes(current) ? current : "en";
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const select = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  return (
    <div className={`ls-wrap ${className}`.trim()} ref={ref}>
      <button
        className="ls-trigger"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <svg
          className="ls-globe"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8"
            cy="8"
            r="6.5"
            stroke="currentColor"
            strokeWidth="1.2"
          />
          <ellipse
            cx="8"
            cy="8"
            rx="2.5"
            ry="6.5"
            stroke="currentColor"
            strokeWidth="1.2"
          />
          <line
            x1="1.5"
            y1="6"
            x2="14.5"
            y2="6"
            stroke="currentColor"
            strokeWidth="1.2"
          />
          <line
            x1="1.5"
            y1="10"
            x2="14.5"
            y2="10"
            stroke="currentColor"
            strokeWidth="1.2"
          />
        </svg>
        <span className="ls-label">{LABELS[value]}</span>
        <svg
          className={`ls-chevron${open ? " open" : ""}`}
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1l4 4 4-4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open && (
        <ul className="ls-menu" role="listbox">
          {SUPPORTED_LANGUAGES.map((lng) => (
            <li
              key={lng}
              className={`ls-option${value === lng ? " active" : ""}`}
              role="option"
              aria-selected={value === lng}
              onClick={() => select(lng)}
            >
              <span className="ls-option-code">{LABELS[lng]}</span>
              <span className="ls-option-name">{FULL_LABELS[lng]}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
